module.exports = __webpack_public_path__ + "static/img/quality-service1.e1b6bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quality-service1.png
// module id = u/ab
// module chunks = 0